export default Object.assign([
  {
    id: 44,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'L\'ourson Teddy d\'Aileen Rogers',
    tags: {
      alfa: 'Vidéo'
    },
    cta: '',
    image: 'CWM-WebsiteTiles-EOTAS-F01-Teddy-72dpi.jpg',
    link: '/apprendre/lourson-teddy-daileen-rogers/',
    cats: {
      themes: [113, 1115],
      types: [75]
    }
  },
  {
    id: 45,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Le porte-monnaie de Grant Campbell',
    tags: {
      alfa: 'Vidéo'
    },
    cta: '',
    image: 'CWM-WebsiteTiles-EOTAS-F01-Purse-72dpi.jpg',
    link: '/apprendre/le-porte-monnaie-de-grant-campbell/',
    cats: {
      themes: [214],
      types: [75]
    }
  },
  {
    id: 46,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'La poupée Izzy',
    tags: {
      alfa: 'Vidéo'
    },
    cta: '',
    image: 'CWM-WebsiteTiles-EOTAS-F01-IzzyDoll-72dpi.jpg',
    link: '/apprendre/la-poupee-izzy-video/',
    cats: {
      themes: [312, 511],
      types: [75]
    }
  },
  {
    id: 47,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'La douille de cartouche des funérailles de Nichola Goddard',
    tags: {
      alfa: 'Vidéo'
    },
    cta: '',
    image: 'CWM-WebsiteTiles-EOTAS-F01-CartridgeCase-72dpi.jpg',
    link: '/apprendre/la-douille-de-cartouche-des-funerailles-de-nichola-goddard/',
    cats: {
      themes: [414, 511, 1115],
      types: [75]
    }
  },
  {
    id: 48,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'La pierre tombale du Soldat inconnu',
    tags: {
      alfa: 'Vidéo'
    },
    cta: '',
    image: 'CWM-WebsiteTiles-EOTAS-F01-UnknownSoldier-72dpi.jpg',
    link: '/apprendre/la-pierre-tombale-du-soldat-inconnu-video/',
    cats: {
      themes: [511, 113],
      types: [75]
    }
  },
  {
    id: 79,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Le drapeau de service de la famille Adie',
    tags: {
      alfa: 'Vidéo'
    },
    cta: '',
    image: 'CWM-WebsiteTiles-EOTAS-F01-ServiceFlag-72dpi.jpg',
    link: '/apprendre/le-drapeau-de-service-de-la-famille-adie/',
    cats: {
      themes: [1311, 113],
      types: [75]
    }
  },
  {
    id: 80,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Une lettre de George Stonefish',
    tags: {
      alfa: 'Vidéo'
    },
    cta: '',
    image: 'CWM-WebsiteTiles-EOTAS-F01-Letter-72dpi.jpg',
    link: '/apprendre/une-lettre-de-george-stonefish/',
    cats: {
      themes: [917, 113],
      types: [75]
    }
  },
  {
    id: 81,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Une photo de Masumi Mitsui',
    tags: {
      alfa: 'Vidéo'
    },
    cta: '',
    image: 'CWM-WebsiteTiles-EOTAS-F01-Photograph-72dpi.jpg',
    link: '/apprendre/une-photo-de-Masumi-mitsui/',
    cats: {
      themes: [113, 214, 511, 1220, 1311],
      types: [75]
    }
  },
  {
    id: 82,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Le certificat de reconnaissance de Minnie Gray',
    tags: {
      alfa: 'Vidéo'
    },
    cta: '',
    image: 'CWM-WebsiteTiles-EOTAS-F01-Certificate-72dpi.jpg',
    link: '/apprendre/le-certificat-de-reconnaissance-de-minnie-gray/',
    cats: {
      themes: [214, 1020, 1115, 1311],
      types: [75]
    }
  },
  {
    id: 83,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Le Musée et le foyer',
    tags: {
      alfa: 'Vidéo'
    },
    cta: '',
    image: 'cwm-websitetiles-itcwt-f01-museum-72dpi.jpg',
    link: ' /apprendre/le-musee-et-le-foyer/',
    cats: {
      themes: [511],
      types: [75]
    }
  },
  {
    id: 84,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'La salle du Souvenir',
    tags: {
      alfa: 'Vidéo'
    },
    cta: '',
    image: 'cwm-websitetiles-itwct-f01-memorialhall-72dpi.jpg',
    link: '/apprendre/la-salle-du-souvenir/',
    cats: {
      themes: [511],
      types: [75]
    }
  },
  {
    id: 88,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'La salle de la régénération Moriyama ',
    tags: {
      alfa: 'Vidéo'
    },
    cta: '',
    image: 'cwm-websitetiles-itwct-f01-moriyama-72dpi.jpg',
    link: '/apprendre/la-salle-de-la-regeneration-moriyama',
    cats: {
      themes: [1220, 511],
      types: [75]
    }
  },
  {
    id: 4,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'L’ourson Teddy',
    tags: {
      alfa: 'Artefact'
    },
    cta: 'En savoir plus',
    image: 'A01-20040015-001.jpg',
    link: '/apprendre/lourson-teddy/',
    cats: {
      themes: [113, 1115],
      types: [38]
    }
  },
  {
    id: 5,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Le drapeau de service',
    tags: {
      alfa: 'Artefact'
    },
    cta: 'En savoir plus',
    image: 'Med06_GR01-20070073-001.jpg', // !!
    link: '/apprendre/le-drapeau-de-service/',
    cats: {
      themes: [113],
      types: [38]
    }
  },
  {
    id: 6,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Porte-monnaie et carte carbonisée',
    tags: {
      alfa: 'Artefact'
    },
    cta: 'En savoir plus',
    image: 'A03-20190232-001_b.jpg',
    link: '/apprendre/porte-monnaie-et-carte-carbonisee/',
    cats: {
      themes: [214],
      types: [38]
    }
  },
  {
    id: 7,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Chaussures endommagées au combat',
    tags: {
      alfa: 'Artefact'
    },
    cta: 'En savoir plus',
    image: 'A04-20170753-001.jpg',
    link: '/apprendre/chaussures-endommagees-au-combat/',
    cats: {
      themes: [214],
      types: [38]
    }
  },
  {
    id: 8,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'La médaille Dag Hammarskjöld',
    tags: {
      alfa: 'Artefact'
    },
    cta: 'En savoir plus',
    image: 'A05-20060217-001.jpg', // !!
    link: '/apprendre/la-medaille-dag-hammarskjold/',
    cats: {
      themes: [312],
      types: [38]
    }
  },
  {
    id: 9,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'La poupée Izzy',
    tags: {
      alfa: 'Artefact'
    },
    cta: 'En savoir plus',
    image: 'A06-19980071-005.jpg',
    link: '/apprendre/la-poupee-izzy/',
    cats: {
      themes: [312],
      types: [38]
    }
  },
  {
    id: 10,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Douille de cartouche',
    tags: {
      alfa: 'Artefact'
    },
    cta: 'En savoir plus',
    image: 'A07-20070158-005.jpg',
    link: '/apprendre/douille-de-cartouche/',
    cats: {
      themes: [414, 1115],
      types: [38]
    }
  },
  {
    id: 11,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Panneau de bande de patinoire',
    tags: {
      alfa: 'Artefact'
    },
    cta: 'En savoir plus',
    image: 'A08-20160664-001.jpg',
    link: '/apprendre/panneau-de-bande-de-patinoire/',
    cats: {
      themes: [414],
      types: [38]
    }
  },
  {
    id: 12,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Coquelicot',
    tags: {
      alfa: 'Artefact'
    },
    cta: 'En savoir plus',
    image: 'A09-19720228-001.jpg',
    link: '/apprendre/coquelicot/',
    cats: {
      themes: [511],
      types: [38]
    }
  },
  {
    id: 13,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'La pierre tombale du Soldat inconnu',
    tags: {
      alfa: 'Artefact'
    },
    cta: 'En savoir plus',
    image: 'A10-20000044-011.jpg',
    link: '/apprendre/la-pierre-tombale-du-soldat-inconnu/',
    cats: {
      themes: [113, 511],
      types: [38]
    }
  },
  {
    id: 49,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Médaille de guerre britannique',
    tags: {
      alfa: 'Artefact'
    },
    cta: 'En savoir plus',
    image: 'A11a_20120205-001.jpg',
    link: '/apprendre/medaille-de-guerre-britannique/',
    cats: {
      themes: [113, 1020],
      types: [38]
    }
  },
  {
    id: 50,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Plaque du Souvenir ',
    tags: {
      alfa: 'Artefact'
    },
    cta: 'En savoir plus',
    image: 'A12a_19950037-010.jpg',
    link: '/apprendre/plaque-du-souvenir/',
    cats: {
      themes: [113, 1115],
      types: [38]
    }
  },
  {
    id: 51,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Croix du Souvenir',
    tags: {
      alfa: 'Artefact'
    },
    cta: 'En savoir plus',
    image: 'A13a_20030051-007008.jpg',
    link: '/apprendre/croix-du-souvenir/',
    cats: {
      themes: [113],
      types: [38]
    }
  },
  {
    id: 52,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Vitrail',
    tags: {
      alfa: 'Artefact'
    },
    cta: 'En savoir plus',
    image: 'A14_19410001-003.jpg',
    link: '/apprendre/vitrail/',
    cats: {
      themes: [113],
      types: [38]
    }
  },
  {
    id: 53,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Ensemble de médailles avec photographie',
    tags: {
      alfa: 'Artefact'
    },
    cta: 'En savoir plus',
    image: 'A15_20170206-001.jpg',
    link: '/apprendre/ensemble-de-medailles-avec-photographie/',
    cats: {
      themes: [214],
      types: [38]
    }
  },
  {
    id: 54,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Casque',
    tags: {
      alfa: 'Artefact'
    },
    cta: 'En savoir plus',
    image: 'A16_19920197-001.jpg',
    link: '/apprendre/casque/',
    cats: {
      themes: [214],
      types: [38]
    }
  },
  {
    id: 55,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Gilet pare-éclats',
    tags: {
      alfa: 'Artefact'
    },
    cta: 'En savoir plus',
    image: 'A17a_20180249-006.jpg',
    link: '/apprendre/gilet-pare-eclats/',
    cats: {
      themes: [312],
      types: [38]
    }
  },
  {
    id: 56,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Maquette du Monument au maintien de la paix',
    tags: {
      alfa: 'Artefact'
    },
    cta: 'En savoir plus',
    image: 'A18a_19960036-001_ongrey.jpg',
    link: '/apprendre/maquette-du-monument-au-maintien-de-la-paix/',
    cats: {
      themes: [312],
      types: [38]
    }
  },
  {
    id: 57,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Bannière',
    tags: {
      alfa: 'Artefact'
    },
    cta: 'En savoir plus',
    image: 'A19_20120114-001.jpg',
    link: '/apprendre/banniere/',
    cats: {
      themes: [414],
      types: [38]
    }
  },
  {
    id: 58,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Drapeau avec inscription',
    tags: {
      alfa: 'Artefact'
    },
    cta: 'En savoir plus',
    image: 'A20_20110171-001.jpg',
    link: '/apprendre/drapeau-avec-inscription/',
    cats: {
      themes: [214, 511, 1311],
      types: [38]
    }
  },
  {
    id: 14,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>Le drapeau</em>',
    tags: {
      alfa: 'Œuvre d’art'
    },
    cta: 'En savoir plus',
    image: 'Art01-19710261-0656.jpg',
    link: '/apprendre/le-drapeau/',
    cats: {
      themes: [113],
      types: [43]
    }
  },
  {
    id: 15,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>À l’assaut, Neuville-Vitasse</em>',
    tags: {
      alfa: 'Œuvre d’art'
    },
    cta: 'En savoir plus',
    image: 'Art02-19710261-0056.jpg',
    link: '/apprendre/a-lassaut-neuville-vitasse/',
    cats: {
      themes: [113],
      types: [43]
    }
  },
  {
    id: 16,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>Derrière les barbelés</em>',
    tags: {
      alfa: 'Œuvre d’art'
    },
    cta: 'En savoir plus',
    image: 'Art03-20130078-001.jpg',
    link: '/apprendre/derriere-les-barbeles/',
    cats: {
      themes: [214],
      types: [43]
    }
  },
  {
    id: 17,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>Poste d’évacuation sanitaire</em>',
    tags: {
      alfa: 'Œuvre d’art'
    },
    cta: 'En savoir plus',
    image: 'Art04-19710261-2042.jpg',
    link: '/apprendre/poste-devacuation-sanitaire/',
    cats: {
      themes: [214],
      types: [43]
    }
  },
  {
    id: 18,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>Gardiens de la paix</em>',
    tags: {
      alfa: 'Œuvre d’art'
    },
    cta: 'En savoir plus',
    image: 'Art05-19970043-001.jpg',
    link: '/apprendre/gardiens-de-la-paix/',
    cats: {
      themes: [312, 1020],
      types: [43]
    }
  },
  {
    id: 19,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Sans titre',
    tags: {
      alfa: 'Œuvre d’art'
    },
    cta: 'En savoir plus',
    image: 'Art06-19970052-001.jpg',
    link: '/apprendre/sans-titre/',
    cats: {
      themes: [312],
      types: [43]
    }
  },
  {
    id: 20,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>Guerre</em>',
    tags: {
      alfa: 'Œuvre d’art'
    },
    cta: 'En savoir plus',
    image: 'Art07-20110073-003.jpg',
    link: '/apprendre/guerre/',
    cats: {
      themes: [414],
      types: [43]
    }
  },
  {
    id: 21,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>Une lente procession</em>',
    tags: {
      alfa: 'Œuvre d’art'
    },
    cta: 'En savoir plus',
    image: 'Art08-20110076-001.jpg',
    link: '/apprendre/une-lente-procession',
    cats: {
      themes: [414, 511],
      types: [43]
    }
  },
  {
    id: 22,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>Dévoilement du Monument commémoratif du Canada à Vimy</em>',
    tags: {
      alfa: 'Œuvre d’art'
    },
    cta: 'En savoir plus',
    image: 'Art09-19670070-014.jpg',
    link: '/apprendre/devoilement-du-monument-commemoratif-du-canada-a-vimy/',
    cats: {
      themes: [511],
      types: [43]
    }
  },
  {
    id: 23,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>Dreaver</em>',
    tags: {
      alfa: 'Œuvre d’art'
    },
    cta: 'En savoir plus',
    image: 'Art10-20180556-001.jpg',
    link: '/apprendre/dreaver/',
    cats: {
      themes: [511, 113, 214, 917, 1311],
      types: [43]
    }
  },
  {
    id: 59,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>Guerrier de Normandie<em>',
    tags: {
      alfa: 'Œuvre d’art'
    },
    cta: 'En savoir plus',
    image: 'Art11_20200359-001.jpg',
    link: '/apprendre/guerrier-de-normandie/',
    cats: {
      themes: [214, 917, 1311],
      types: [43]
    }
  },
  {
    id: 60,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>Le défilé<em>',
    tags: {
      alfa: 'Œuvre d’art'
    },
    cta: 'En savoir plus',
    image: 'Art12_il2008006-001_lower.jpg',
    link: '/apprendre/le-defile/',
    cats: {
      themes: [214, 1115, 1311],
      types: [43]
    }
  },
  {
    id: 61,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '<em>Retour en oiseau<em>',
    tags: {
      alfa: 'Œuvre d’art'
    },
    cta: 'En savoir plus',
    image: 'Art13_20170667-001.jpg',
    link: '/apprendre/retour-en-oiseau/',
    cats: {
      themes: [214, 1311],
      types: [43]
    }
  },
  {
    id: 24,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Rapport sur les circonstances de décès',
    tags: {
      alfa: 'Document'
    },
    cta: 'En savoir plus',
    image: 'Doc01-20040015-007.jpg',
    link: '/apprendre/rapport-sur-les-circonstances-de-deces/',
    cats: {
      themes: [113],
      types: [58]
    }
  },
  {
    id: 25,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Carte postale du service de campagne',
    tags: {
      alfa: 'Document'
    },
    cta: 'En savoir plus',
    image: 'Doc02-20060194-002_1.jpg',
    link: '/apprendre/carte-postale-du-service-de-campagne/',
    cats: {
      themes: [113],
      types: [58]
    }
  },
  {
    id: 26,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Lettre datée du 4 juin 1944',
    tags: {
      alfa: 'Document'
    },
    cta: 'En savoir plus',
    image: 'Doc03-20050108-003.jpg',
    link: '/apprendre/lettre-datee-du-4-juin-1944/',
    cats: {
      themes: [214],
      types: [58]
    }
  },
  {
    id: 27,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Lettre datée du 19 février 1944',
    tags: {
      alfa: 'Document'
    },
    cta: 'En savoir plus',
    image: 'Doc04-20030359-028_28_p1.jpg',
    link: '/apprendre/lettre-datee-du-19-fevrier-1944/',
    cats: {
      themes: [214, 1115],
      types: [58]
    }
  },
  {
    id: 28,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Lettre datée du 2 juin 2000',
    tags: {
      alfa: 'Document'
    },
    cta: 'En savoir plus',
    image: 'Doc05-20130617-001_16_June_2000.jpg',
    link: '/apprendre/lettre-datee-du-2-juin-2000/',
    cats: {
      themes: [312, 1115],
      types: [58]
    }
  },
  {
    id: 29,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Site no 6 — Diagramme de blessures et résumé des faits',
    warningText: '<p><strong>Avertissement:</strong> Ce document contient des descriptions détaillées et explicites des blessures d’une victime de génocide ethnique trouvée par des Canadiens participant à une mission de maintien de la paix. Le contenu pourrait ne pas convenir à certaines personnes. <strong>Veuillez vérifier si cette ressource est appropriée avant de la sélectionner</strong>.</p>',
    tags: {
      alfa: 'Document',
      warning: 'Avertissement'
    },
    cta: 'En savoir plus',
    image: 'Doc06-20160257-003_Site-No6_Illustration.jpg',
    link: '/apprendre/site-no-6-diagramme-de-blessures-et-resume-des-faits/',
    cats: {
      themes: [312],
      types: [58]
    }
  },
  {
    id: 30,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Mon journal de mission',
    tags: {
      alfa: 'Document'
    },
    cta: 'En savoir plus',
    image: 'Doc07_20100094-003_1.jpg',
    link: '/apprendre/mon-journal-de-mission/',
    cats: {
      themes: [414],
      types: [58]
    }
  },
  {
    id: 31,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Bulletin de vote des élections présidentielles à Kaboul',
    tags: {
      alfa: 'Document'
    },
    cta: 'En savoir plus',
    image: 'Doc08-20060136-001.jpg',
    link: '/apprendre/bulletin-de-vote-des-elections-presidentielles-a-kaboul/',
    cats: {
      themes: [414],
      types: [58]
    }
  },
  {
    id: 32,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '« In Flanders’ Fields » Au champ d’honneur',
    tags: {
      alfa: 'Document'
    },
    cta: 'En savoir plus',
    image: 'Doc09-20060073-001.jpg',
    link: '/apprendre/au-champ-dhonneur/',
    cats: {
      themes: [511, 113],
      types: [58]
    }
  },
  {
    id: 33,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Programme, Cérémonie nationale du jour du Souvenir, 1934',
    tags: {
      alfa: 'Document'
    },
    cta: 'En savoir plus',
    image: 'Doc10-19990092-068_eng.jpg',
    link: '/apprendre/programme-ceremonie-nationale-du-jour-du-souvenir-1934/',
    cats: {
      themes: [511],
      types: [58]
    }
  },
  {
    id: 62,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Album de coupures',
    tags: {
      alfa: 'Document'
    },
    cta: 'En savoir plus',
    image: 'Doc11a_20160159-001_p3.jpg',
    link: '/apprendre/album-de-coupures/',
    cats: {
      themes: [113, 1020, 1311],
      types: [58]
    }
  },
  {
    id: 63,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Certificat de reconnaissance publique',
    tags: {
      alfa: 'Document'
    },
    cta: 'En savoir plus',
    image: 'Doc12a_20110057-009.jpg',
    link: '/apprendre/certificat-de-reconnaissance-publique/',
    cats: {
      themes: [214, 1020, 1115, 1311],
      types: [58]
    }
  },
  {
    id: 64,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Article de journal, le 18&nbsp;juin&nbsp;1945',
    tags: {
      alfa: 'Document'
    },
    cta: 'En savoir plus',
    image: 'Doc13_WindsorStar18June45p3_JosephHong.jpg',
    link: '/apprendre/article-de-journal-le-18-juin-1945/',
    cats: {
      themes: [214, 1220],
      types: [58]
    }
  },
  {
    id: 65,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Lettres, le 13&nbsp;septembre&nbsp;1979 et le 6&nbsp;janvier&nbsp;1980',
    tags: {
      alfa: 'Document'
    },
    cta: 'En savoir plus',
    image: 'Doc14a_20030023-062_6-Jan-1980.jpg',
    link: '/apprendre/lettres-le-13-septembre-1979-et-le-6-janvier-1980/',
    cats: {
      themes: [312, 1220],
      types: [58]
    }
  },
  {
    id: 66,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Carte brodée, le 2&nbsp;décembre&nbsp;1916',
    tags: {
      alfa: 'Document'
    },
    cta: 'En savoir plus',
    image: 'Doc15a_19830409-005_front.jpg',
    link: '/apprendre/carte-brodee-le-2-decembre-1916/',
    cats: {
      themes: [113, 917],
      types: [58]
    }
  },
  {
    id: 67,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Lettre, le 18&nbsp;août&nbsp;1915',
    tags: {
      alfa: 'Document'
    },
    cta: 'En savoir plus',
    image: 'Doc16a1_20070019-001_18-Aug-1915_1.jpg',
    link: '/apprendre/lettre-le-18-aout-1915/',
    cats: {
      themes: [113, 917],
      types: [58]
    }
  },
  {
    id: 68,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Achetez un coquelicot…',
    tags: {
      alfa: 'Document'
    },
    cta: 'En savoir plus',
    image: 'Doc17a_Poppy-Campaign-ad.jpg',
    link: '/apprendre/achetez-un-coquelicot/',
    cats: {
      themes: [511, 1115],
      types: [58]
    }
  },
  {
    id: 69,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Lauréats du concours d’affiches de la Légion royale canadienne, 2020',
    tags: {
      alfa: 'Document'
    },
    cta: 'En savoir plus',
    image: 'Doc18a_Maximilian-Lee.jpg',
    link: '/apprendre/laureats-du-concours-daffiches-de-la-legion-royale-canadienne-2020/',
    cats: {
      themes: [511],
      types: [58]
    }
  },
  {
    id: 70,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Article de journal, le 12&nbsp;novembre&nbsp;1941',
    tags: {
      alfa: 'Document'
    },
    cta: 'En savoir plus',
    image: 'Doc19_Ott-Citizen-12-Nov-1941-p-22_Armistice-of-1918.jpg',
    link: '/apprendre/article-de-journal-le-12-novembre-1941/',
    cats: {
      themes: [511, 214],
      types: [58]
    }
  },
  {
    id: 34,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '107<sup>e</sup> bataillon de pionniers ',
    tags: {
      alfa: 'Photo'
    },
    cta: 'En savoir plus',
    image: 'P01-il2015015-005.jpg',
    link: '/apprendre/107e-bataillon-de-pionniers/',
    cats: {
      themes: [113, 917],
      types: [610]
    }
  },
  {
    id: 35,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Quartier général, Shorncliffe Corps vétérinaire royal canadien',
    tags: {
      alfa: 'Photo'
    },
    cta: 'En savoir plus',
    image: 'P02-19930003-453.jpg',
    link: '/apprendre/quartier-general-corps-veterinaire-royal-canadien/',
    cats: {
      themes: [113],
      types: [610]
    }
  },
  {
    id: 36,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Le soldat Mary Greyeyes, de la Nation Maskêko-Sâkahikanihk (Nation crie de Muskeg Lake), Service féminin de l’Armée canadienne, avec Harry Ball, de la Première Nation de Piapot',
    tags: {
      alfa: 'Photo'
    },
    cta: 'En savoir plus',
    image: 'P03-PA-129070.jpg',
    link: '/apprendre/le-soldat-mary-greyeyes/',
    cats: {
      themes: [214, 917, 1115],
      types: [610]
    }
  },
  {
    id: 37,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: '53, avenue Redwood, Toronto',
    tags: {
      alfa: 'Photo'
    },
    cta: 'En savoir plus',
    image: 'P04-20180400-002_1.jpg',
    link: '/apprendre/53-avenue-redwood-toronto/',
    cats: {
      themes: [214, 1020],
      types: [610]
    }
  },
  {
    id: 38,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Équipe de la Mission des Nations Unies pour l’assistance au Rwanda',
    tags: {
      alfa: 'Photo'
    },
    cta: 'En savoir plus',
    image: 'P05-20140588-002-3.jpg',
    link: '/apprendre/equipe-de-la-mission-des-nations-unies-pour-lassistance-au-rwanda/',
    cats: {
      themes: [312],
      types: [610]
    }
  },
  {
    id: 39,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Opération HAMLET',
    tags: {
      alfa: 'Photo'
    },
    cta: 'En savoir plus',
    image: 'P06-IS2013-2002-058.jpg',
    link: '/apprendre/operation-hamlet/',
    cats: {
      themes: [312],
      types: [610]
    }
  },
  {
    id: 40,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Opération ATHENA, clinique',
    tags: {
      alfa: 'Photo'
    },
    cta: 'En savoir plus',
    image: 'P07-AR2008-Z103-19.jpg',
    link: '/apprendre/operation-athena-clinique/',
    cats: {
      themes: [414, 1115],
      types: [610]
    }
  },
  {
    id: 41,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Opération ATHENA, compagnie de protection de la force',
    tags: {
      alfa: 'Photo'
    },
    cta: 'En savoir plus',
    image: 'P08-IS2007-1018.jpg',
    link: '/apprendre/operation-athena-compagnie-de-protection-de-la-force/',
    cats: {
      themes: [414],
      types: [610]
    }
  },
  {
    id: 42,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Dévoilement officiel du Mémorial de Vimy',
    tags: {
      alfa: 'Photo'
    },
    cta: 'En savoir plus',
    image: 'P09-19830626-001_3.jpg',
    link: '/apprendre/devoilement-officiel-du-memorial-de-vimy/',
    cats: {
      themes: [511, 1115, 1220],
      types: [610]
    }
  },
  {
    id: 43,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Défilé du 100<sup>e</sup> anniversaire',
    tags: {
      alfa: 'Photo'
    },
    cta: 'En savoir plus',
    image: 'P10_IS13-2018-0004-010.jpg',
    link: '/apprendre/defile-du-100e-anniversaire/',
    cats: {
      themes: [511],
      types: [610]
    }
  },
  {
    id: 71,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Pont commémoratif Ainsworth-Dyer, Edmonton (Alberta)',
    tags: {
      alfa: 'Photo'
    },
    cta: 'En savoir plus',
    image: 'P11a_39824078.jpg',
    link: '/apprendre/pont-commemoratif-ainsworth-dyer-edmonton-alberta/',
    cats: {
      themes: [414, 1020],
      types: [610]
    }
  },
  {
    id: 72,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Membres de la communauté canadienne-japonaise en deuil, Vancouver (Colombie-Britannique)',
    tags: {
      alfa: 'Photo'
    },
    cta: 'En savoir plus',
    image: 'P12_2001-11-054-Funeral.jpg',
    link: '/apprendre/membres-de-la-communaute-canadienne-japonaise-en-deuil-vancouver-colombie-britannique/',
    cats: {
      themes: [113, 1220],
      types: [610]
    }
  },
  {
    id: 72,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Cérémonie à la tombe de Buckam Singh, ancien combattant',
    tags: {
      alfa: 'Photo'
    },
    cta: 'En savoir plus',
    image: 'P13_sandeep-brar.jpg',
    link: '/apprendre/ceremonie-a-la-tombe-de-buckam-singh-ancien-combattant/',
    cats: {
      themes: [113, 511, 1220],
      types: [610]
    }
  },
  {
    id: 73,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Masumi Mitsui tenant une photo de lui-même en uniforme pendant la Première Guerre mondiale',
    tags: {
      alfa: 'Photo'
    },
    cta: 'En savoir plus',
    image: 'P14_Mitsui_2014-10-1-7.jpg',
    link: '/apprendre/masumi-mitsui-tenant-une-photo-de-lui-meme-en-uniforme-pendant-la-premiere-guerre-mondiale/',
    cats: {
      themes: [113, 214, 511, 1311, 1220],
      types: [610]
    }
  },
  {
    id: 74,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Coupe Memorial',
    tags: {
      alfa: 'Photo'
    },
    cta: 'En savoir plus',
    image: 'P15a_130516_Cup_Arrival.jpg',
    link: '/apprendre/coupe-memorial/',
    cats: {
      themes: [113],
      types: [610]
    }
  },
  {
    id: 75,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Lily et Donald Worden sur la tombe d\'Edwin Worden',
    tags: {
      alfa: 'Photo'
    },
    cta: 'En savoir plus',
    image: 'P16_19800746-010.jpg',
    link: '/apprendre/lily-et-donald-worden-sur-la-tombe-dedwin-worden/',
    cats: {
      themes: [214],
      types: [610]
    }
  },
  {
    id: 76,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Le jour du Souvenir chez Tim Hortons à Kandahar, en Afghanistan',
    tags: {
      alfa: 'Photo'
    },
    cta: 'En savoir plus',
    image: 'P17a_Tims-Poppies-7.jpg',
    link: '/apprendre/le-jour-du-souvenir-chez-tim-hortons-a-Kandahar-en-afghanistan',
    cats: {
      themes: [511, 1115, 414],
      types: [610]
    }
  },
  {
    id: 77,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Funérailles en mer',
    tags: {
      alfa: 'Photo'
    },
    cta: 'En savoir plus',
    image: 'P18_20000224-028_7.jpg',
    link: '/apprendre/funerailles-en-mer/',
    cats: {
      themes: [214],
      types: [610]
    }
  },
  {
    id: 50,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Le Canada et la Première Guerre mondiale',
    tags: {
      alfa: 'Survol historique'
    },
    cta: 'En savoir plus',
    image: 'Ov01-19930013-464.jpg',
    link: '/apprendre/le-canada-et-la-premiere-guerre-mondiale/',
    cats: {
      themes: [113],
      types: [218]
    }
  },
  {
    id: 51,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Le Canada et la Seconde Guerre mondiale',
    tags: {
      alfa: 'Survol historique'
    },
    cta: 'En savoir plus',
    image: 'Ov02-PA-113659.jpg',
    link: '/apprendre/le-canada-et-la-seconde-guerre-mondiale/',
    cats: {
      themes: [214],
      types: [218]
    }
  },
  {
    id: 52,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Le Canada et les opérations de maintien de la paix',
    tags: {
      alfa: 'Survol historique'
    },
    cta: 'En savoir plus',
    image: 'Ov03-19910238-130.jpg',
    link: '/apprendre/le-canada-et-les-operations-de-maintien-de-la-paix/',
    cats: {
      themes: [312],
      types: [218]
    }
  },
  {
    id: 53,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Le Canada et la guerre en Afghanistan',
    tags: {
      alfa: 'Survol historique'
    },
    cta: 'En savoir plus',
    image: 'Ov04-AR2006-P005-0031.jpg',
    link: '/apprendre/le-canada-et-la-guerre-en-afghanistan/',
    cats: {
      themes: [414],
      types: [218]
    }
  },
  {
    id: 54,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Le Canada se souvient',
    tags: {
      alfa: 'Survol historique'
    },
    cta: 'En savoir plus',
    image: 'ov5_cwn2011-0065-0006-dp1.jpg',
    link: '/apprendre/le-canada-se-souvient/',
    cats: {
      themes: [511],
      types: [218]
    }
  },
  {
    id: 78,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Les femmes dans les Forces armées canadiennes',
    tags: {
      alfa: 'Survol historique'
    },
    cta: 'En savoir plus',
    image: 'ov7_e010777310-v8_1.jpg',
    link: '/apprendre/les-femmes-dans-les-forces-armees-canadiennes',
    cats: {
      themes: [113, 214, 1115],
      types: [218]
    }
  },
  {
    id: 85,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Les vétérans du Canada',
    tags: {
      alfa: 'Survol historique'
    },
    cta: 'En savoir plus',
    image: 'cwm2018-0037-0058-dm.jpg',
    link: '/apprendre/les-veterans-du-canada/',
    cats: {
      themes: [1311, 113, 214, 511],
      types: [218]
    }
  },
  {
    id: 86,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Les peuples autochtones et les forces armées du Canada ',
    tags: {
      alfa: 'Survol historique'
    },
    cta: 'En savoir plus',
    image: 'arnold-moses-front-right-wesley-burnham-front-left-107th-battalion-cef.jpg',
    link: '/apprendre/les-peuples-autochtones-et-les-forces-armees-du-canada/',
    cats: {
      themes: [917],
      types: [218]
    }
  },
  {
    id: 87,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Les Canadiens d’origine asiatique et les forces armées du Canada',
    tags: {
      alfa: 'Survol historique'
    },
    cta: 'En savoir plus',
    image: '1942-chinese-canadian-recruits-victoria.jpg',
    link: '/apprendre/les-canadiens-dorigine-asiatique-et-les-forces-armees-du-canada/',
    cats: {
      themes: [1220],
      types: [218]
    }
  },
  {
    id: 88,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Les Canadiens noirs et les forces armées du Canada',
    tags: {
      alfa: 'Survol historique'
    },
    cta: 'En savoir plus',
    image: 'ov10_lac-pa-22980_cropped.jpg',
    link: '/apprendre/les-canadiens-noirs-et-les-forces-armees-du-canada/',
    cats: {
      themes: [1020],
      types: [218]
    }
  },
  {
    id: 1,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    // ^ Utility props!, consider moving to keep ensure base data is in fact data only.
    // .. of course, not a priority since it likely won't matter much ;-)
    title: 'Organisation d’une cérémonie du jour du Souvenir',
    // desc: "Developed to mark the 75th anniversary of the end of the Second World War, Forever Changed weaves together a diverse range of stories with nearly 200 compelling artifacts, exploring the human experience ...",
    tags: {
      alfa: 'Activité'
    },
    cta: 'En savoir plus',
    image: false,
    link: '/apprendre/organisation-dune-ceremonie-du-jour-du-souvenir/',
    cats: {
      themes: [511],
      types: [18]
    }
  },
  {
    id: 2,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'Discussion sur l’art et la photographie',
    tags: {
      alfa: 'Activité'
    },
    cta: 'En savoir plus',
    image: false,
    link: '/apprendre/discussion-sur-lart-et-la-photographie/',
    cats: {
      themes: [],
      types: [18]
    }
  },
  {
    id: 200,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'L’analyse d’une source primaire',
    tags: {
      alfa: 'Activité'
    },
    cta: 'En savoir plus',
    image: false,
    link: '/apprendre/lanalyse-dune-source-primaire/',
    cats: {
      themes: [],
      types: [18]
    }
  },
  {
    id: 3,
    isActive: true,
    subClasses: ['mu-grid'],
    // ***
    title: 'L’analyse d’un Artefact',
    tags: {
      alfa: 'Activité'
    },
    cta: 'En savoir plus',
    image: false,
    link: '/apprendre/lanalyse-dun-artefact/',
    cats: {
      themes: [],
      types: [18]
    }
  }
]);